/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';

const MainContentPlaceholderComponent = () => {
    return (
        <div className="content content-page">

            <div className="content-wrapper page-wrapper page-summary-placehoder">
                <div className="summary-row disable-event">
                    <div className="summary-row-content">
                        <div className="col-head">
                            <div className="comp-placeholder placeholder-avatar"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-admin flex-default !w-52 flex-direction-column !pr-16">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-groups flex-default !w-16 flex-direction-column !pr-16">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-groups flex-default !w-16 flex-direction-column !pr-16">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-groups flex-default !w-16 flex-direction-column !pr-24">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                    </div>
                </div>
                <div className="summary-row disable-event">
                    <div className="summary-row-content">
                        <div className="col-head">
                            <div className="comp-placeholder placeholder-avatar"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-admin flex-default !w-52 flex-direction-column !pr-16">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-groups flex-default !w-16 flex-direction-column !pr-16">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-groups flex-default !w-16 flex-direction-column !pr-16">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                        <div className="col-summary col-groups flex-default !w-16 flex-direction-column !pr-24">
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-full"></div>
                            <div className="comp-placeholder placeholder-text-two-thirds"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainContentPlaceholderComponent;